import React, { useState, useContext } from 'react'
import { t } from 'i18next'
import AccessContext from '../../context/AccessContext/AccessContext';
import ButtonBlackReturn from '../Buttons/ButtonBlackReturn';
import { ButtonBlue } from '../Buttons/ButtonBlue';
import AccessVehiclesContext from '../../context/AccessVehiclesContext/AccessVehiclesContext';
import { ButtonBlueNoBorder } from '../Buttons/ButtonBlueNoBorder';
import VehicleVisit from '../Vehicle/VehicleVisit';
import { getTenantInfoByKey, getUserBuilding, replaceExpecialCharacters } from '../../helpers/helpers';
import { FormCheckModal } from './FormCheckModal';
import useWindowSize from '../../customHooks/useWindowSize';
import { RepeatedPlateErrorModal } from './RepeatedPlateErrorModal';

const VehicleForm = () => {

    const { windowWidth } = useWindowSize()

    const { setStep, accessState } = useContext(AccessContext);
    const { accessWithEquipmentOrTools } = accessState;

    const { setAccessVehiclesSelected, accessVehiclesState, cleanAccessVehiclesState } = useContext(AccessVehiclesContext);
    const { accessVehiclesSelected, initialStateVisitVehicle } = accessVehiclesState;


    const [repeatedVehicleAlertModal, setRepeatedVehicleAlertModal] = useState({
        showModal: false,
        setShowModal: () => setRepeatedVehicleAlertModal({ ...repeatedVehicleAlertModal, showModal: false }),
        repeatedPlateNumbers: []
    });

    const [visitVehicles, setVisitVehicles] = useState(accessVehiclesSelected);

    const [visitVehicle, setVisitVehicle] = useState(initialStateVisitVehicle);

    const [checkFormModal, setCheckFormModal] = useState({
        showModal: false,
        setShowModal: () => setCheckFormModal({ ...checkFormModal, showModal: false }),
        reason: '',
        cuestion: '',
        actionText: '',
        onClickAction: null
    })

    const { showModal, setShowModal } = checkFormModal;

    const disabled = !!!visitVehicle.plate_number.trim() || !!!visitVehicle.description.trim()

    const handleChange = (e) => {
        const { value, name } = e.target;
        setVisitVehicle({
            ...visitVehicle,
            [name]: replaceExpecialCharacters(value)
        })
    }

    const findRepeatedPlates = (plateNumbers) => {
        const seenPlates = new Set();
        const repeatedPlates = new Set();

        plateNumbers.forEach(vehicle => {
            const plate = vehicle.plate_number.toLowerCase();
            if (seenPlates.has(plate)) {
                repeatedPlates.add(plate);
            } else {
                seenPlates.add(plate);
            }
        });

        return [...repeatedPlates];
    }

    const onSubmit = (e) => {
        e.preventDefault();
        if (disabled) return
        
        const repeatedPlatesNumber = findRepeatedPlates([...visitVehicles, visitVehicle]);

        if (repeatedPlatesNumber.length) {

            setRepeatedVehicleAlertModal({
                ...repeatedVehicleAlertModal,
                showModal: true,
                repeatedPlateNumbers: repeatedPlatesNumber
            })

            return
        }

        setVisitVehicles([...visitVehicles, visitVehicle]);
        setVisitVehicle({
            plate_number: '',
            observations: '',
            description: '',
        });
    };

    const handleNextStep = (visitVehicles) => {

        const repeatedPlatesNumber = findRepeatedPlates(visitVehicles);

        if (repeatedPlatesNumber.length) {

            if (!checkFormModal.showModal) {
                setCheckFormModal({
                    ...checkFormModal,
                    showModal: false,
                })
            }

            setRepeatedVehicleAlertModal({
                ...repeatedVehicleAlertModal,
                showModal: true,
                repeatedPlateNumbers: repeatedPlatesNumber
            })

            return
        }

        setAccessVehiclesSelected(visitVehicles);

        setVisitVehicle({
            plate_number: '',
            observations: '',
            description: '',
        });

        const haveAccessBuildings = getUserBuilding().buildingDescription !== t('NO_BUILDING');;

        const havePersonsToVisit = getTenantInfoByKey('has_people_to_visit');

        if (accessWithEquipmentOrTools) {
            setStep('SELECT_EQUIPMENT_OR_TOOLS')
            return
        }

        if (haveAccessBuildings) {
            setStep('SELECT_AREA')
            return
        }

        if (havePersonsToVisit) {
            setStep('SELECT_PERSON_TO_VISIT')
            return
        }

        setStep('DETAIL');
        return
    }

    const handleCheckInfo = () => {

        if (disabled === false) {
            setCheckFormModal({
                ...checkFormModal,
                showModal: true,
                reason: t('VEHICLE_DATA_NO_CONFIRM'),
                cuestion: t('DO_YOU_WANT_TO_ADD'),
                actionText: t('ADD'),
                onClickAction: () => {
                    handleNextStep([...visitVehicles, visitVehicle]);
                },
            })
            return
        }

        if (!!visitVehicle.plate_number.trim() && !visitVehicle.description.trim()) {
            setCheckFormModal({
                ...checkFormModal,
                showModal: true,
                reason: t('VEHICLE_DATA_NO_COMPLETED'),
                cuestion: t('DO_YOU_WANT_TO_COMPLETE'),
                actionText: t('COMPLETE'),
                onClickAction: setShowModal,
            })
            return
        }

        handleNextStep(visitVehicles);
    }

    const handleReturnStep = () => {
        setStep('ACCESS_WITH')
        cleanAccessVehiclesState();
    }

    const handleEdit = (vehicle, index) => {
        setVisitVehicle(vehicle);
        setVisitVehicles(visitVehicles.slice(0, index).concat(visitVehicles.slice(index + 1)));
    }

    const handleDelete = (index) => {
        setVisitVehicles(visitVehicles.slice(0, index).concat(visitVehicles.slice(index + 1)));
    }

    return (
        <>
            {showModal && (
                <FormCheckModal
                    {...checkFormModal}
                    onClickContinue={() => handleNextStep(visitVehicles)}
                />
            )}

            {repeatedVehicleAlertModal.showModal && (
                <RepeatedPlateErrorModal
                    showModal={repeatedVehicleAlertModal.showModal}
                    setShowModal={repeatedVehicleAlertModal.setShowModal}
                    repeatedPlates={repeatedVehicleAlertModal.repeatedPlateNumbers}
                />
            )}

            <div className='d-flex flex-column justify-content-between h-100'>
                <div>
                    {
                        visitVehicles.length > 0 ?
                            <div
                                className="d-flex flex-column gap-3 no-show-scroll mb-3"
                                style={{ maxHeight: windowWidth < 567 ? '150px' : '300px', overflowX: 'auto' }}
                            >
                                {
                                    visitVehicles.map((visitVehicle, idx) =>
                                        <VehicleVisit
                                            key={idx}
                                            visitVehicle={visitVehicle}
                                            onClickDelete={() => handleDelete(idx)}
                                            onClickEdit={() => handleEdit(visitVehicle, idx)}
                                        />
                                    )
                                }
                            </div>
                            :
                            null
                    }
                    <form
                        className='d-flex flex-column justify-content-between gap-4'
                        onSubmit={onSubmit}
                    >
                        <div className='d-flex flex-column gap-4'>
                            <div>
                                <label
                                    htmlFor="plate_number"
                                    className='form-label blue-dark-text'
                                >
                                    {t('PATENT')}
                                </label>
                                <input
                                    className='form-control'
                                    type="text"
                                    name='plate_number'
                                    value={visitVehicle.plate_number}
                                    onChange={handleChange}
                                    placeholder={t('ENTER_VEHICLE_VISIT_PATENT')}
                                    maxLength={13}
                                />
                            </div>

                            <div>
                                <label
                                    htmlFor="model"
                                    className='form-label blue-dark-text'
                                >
                                    {t('BND_MOD')}
                                </label>
                                <input
                                    className='form-control'
                                    type="text"
                                    name='description'
                                    maxLength={200}
                                    value={visitVehicle.description}
                                    onChange={handleChange}
                                    placeholder={t('ENTER_VEHICLE_VISIT_MODEL')}
                                />
                            </div>

                            <div>
                                <label
                                    htmlFor="description"
                                    className='form-label blue-dark-text'
                                >
                                    {t('OBSERVATIONS')}
                                </label>
                                <input
                                    className='form-control'
                                    type="text"
                                    name='observations'
                                    value={visitVehicle.observations}
                                    onChange={handleChange}
                                    maxLength={255}
                                    placeholder={t('ENTER_OBSERVATIONS')}
                                />
                            </div>

                            <div className='ms-auto'>
                                <ButtonBlueNoBorder
                                    type='submit'
                                    disabled={disabled}
                                    className='border-0'
                                >
                                    {t('ADD')}
                                </ButtonBlueNoBorder>
                            </div>
                        </div>
                    </form>
                </div>

                <div className='d-flex justify-content-between align-items-center mt-4 mb-4'>
                    <div className="w-75">
                        <ButtonBlackReturn
                            title={t('GET_BACK')}
                            onClick={handleReturnStep}
                        />
                    </div>
                    <div className="w-50">
                        <ButtonBlue
                            className='w-100'
                            onClick={handleCheckInfo}
                        >
                            {t('NEXT')}
                        </ButtonBlue>
                    </div>
                </div>

            </div>
        </>
    )
}

export default VehicleForm